const UserConfig = {
  endpoints: {
    deleteAccount: "/account/requestdelete",
    confirmDeleteAccount: "/account/confirmdelete",
    cancelDelete: "/account/canceldelete",
    confirmCancelDelete: "/account/confirmcanceldelete",
    checkDeletion: "/account/goingtobedeleted",
    settings: {
      edit: "/usersettings/edit",
      get: "/usersettings/show",
      isPayedUser: "/usersettings/ispayeduser"
    },
    profilePicture: {
      /** own image bytes; 204 when none is set */
      me: "/profilepicture/me",
      /** + user id: that member's image bytes; 204 when none or not visible */
      user: "/profilepicture/user/",
      /** PUT { file_string, file_name } */
      upload: "/profilepicture/",
      /** DELETE */
      remove: "/profilepicture/"
    },
    assistant: {
      setFirstLoginFalse: "/setup/assistant/setfirstloginfalse"
    },
    social: {
      gmail: {
        getAuthUrl: "/connections/gmail/getauthurl",
        connect: "/connections/gmail/connect",
        isConneted: "/connections/gmail/isconnected",
        refreshConnection: "/connections/gmail/refreshconnection",
        disconnect: "/connections/gmail/disconnect"
      }
    }
  }
};

export default UserConfig;
